import styled from 'styled-components';
import guberlogo from 'lib/assets/images/gbr-logo-primary-hor-white.png';
import { brand } from 'themes/brand';

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: ${brand.navy};
  padding: 8px 0;
  box-sizing: border-box;
`;

export const Box = styled.div`
  display: flex;
  align-items: center;

  div:first-child {
    padding-right: 50px;
    margin-right: 50px;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  span {
    color: #efefef;
    font-size: 10pt;
    margin-left: 45px;
  }

  p {
    color: #efefef;
    font-size: 12pt;
  }
`;

export const GuberLogo = styled.div`
  width: 160px;
  height: 24px;
  background-image: url(${guberlogo});
  background-repeat: no-repeat;
  background-size: contain;
  margin-top: 3px;
`;
